import { ChartProcessorContext, isVegaLiteSpec } from './index';

export function processPieChart({ spec, width, height, isBig }: ChartProcessorContext) {
    const newSpec = { ...spec };

    if (isVegaLiteSpec(newSpec)) {
        if (width && height) {
            const radius = Math.min(width, height) / 3;
            const innerRadius = radius * 0.6;

            const originalMark =
                typeof (newSpec as any).mark === 'string'
                    ? { type: (newSpec as any).mark }
                    : (newSpec as any).mark || {};

            const arcMark = {
                ...originalMark,
                type: 'arc',
                innerRadius,
                outerRadius: radius,
                tooltip: true,
            };

            const textMark = {
                type: 'text',
                radius: isBig ? radius + 25 : radius + 15,
                fontSize: isBig ? 14 : 10,
            };

            const encoding = (newSpec as any).encoding ? { ...(newSpec as any).encoding } : {};
            const thetaField = encoding.theta?.field;
            const thetaType = encoding.theta?.type || 'quantitative';
            const colorField = encoding.color?.field;
            const colorType = encoding.color?.type || 'nominal';

            const arcEncoding = { ...encoding };
            arcEncoding.theta = { ...arcEncoding.theta, stack: true };

            const tooltipItems = [];
            const thetaTitle = encoding.theta?.title || thetaField;
            const colorTitle = encoding.color?.legend?.title || colorField;

            if (colorField) {
                tooltipItems.push({
                    field: colorField,
                    type: colorType,
                    title: colorTitle,
                });
            }

            if (thetaField) {
                tooltipItems.push({
                    field: 'label',
                    type: 'nominal',
                    title: thetaTitle,
                });
            }

            const labelTransform = thetaField
                ? [
                      {
                          calculate: `
                        datum[${JSON.stringify(thetaField)}] >= 1e12 ? format(datum[${JSON.stringify(thetaField)}] / 1e12, '.1f') + 'T' :
                        datum[${JSON.stringify(thetaField)}] >= 1e9  ? format(datum[${JSON.stringify(thetaField)}] / 1e9,  '.1f') + 'B' :
                        datum[${JSON.stringify(thetaField)}] >= 1e6  ? format(datum[${JSON.stringify(thetaField)}] / 1e6,  '.1f') + 'M' :
                        datum[${JSON.stringify(thetaField)}] >= 1e3  ? format(datum[${JSON.stringify(thetaField)}] / 1e3,  '.1f') + 'K' :
                        datum[${JSON.stringify(thetaField)}]
                    `,
                          as: 'label',
                      },
                  ]
                : [];

            if (tooltipItems.length > 0) {
                arcEncoding.tooltip = tooltipItems;
            }

            (newSpec as any).encoding = arcEncoding;
            (newSpec as any).transform = labelTransform;

            (newSpec as any).layer = [
                {
                    mark: arcMark,
                },
                {
                    mark: textMark,
                    encoding: {
                        text: { field: 'label', type: 'nominal' },
                    },
                },
            ];

            delete (newSpec as any).mark;
        }
    } else {
        if (width && height) {
            (newSpec as any).signals = [
                { name: 'width', value: width * 0.6 },
                { name: 'height', value: height * 0.6 },
            ];
        }

        if (Array.isArray((newSpec as any).marks)) {
            (newSpec as any).marks = (newSpec as any).marks.map((mark: any) => {
                if (mark.type === 'arc' && mark.encode?.update) {
                    return {
                        ...mark,
                        encode: {
                            ...mark.encode,
                            update: {
                                ...mark.encode.update,
                                innerRadius: {
                                    signal: 'min(width, height) / 2 * 0.6',
                                },
                            },
                        },
                    };
                }
                return mark;
            });
        }
    }

    return newSpec;
}
